import React from 'react';
import Container from './Container';
import useScrollAnimation from '../hooks/useScrollAnimation';

const AboutGuidingPillars = () => {
  const headerRef = useScrollAnimation('scroll-animate-blur');
  const pillar1Ref = useScrollAnimation('scroll-animate-stagger');
  const pillar2Ref = useScrollAnimation('scroll-animate-stagger');
  const pillar3Ref = useScrollAnimation('scroll-animate-stagger');
  const pillar4Ref = useScrollAnimation('scroll-animate-stagger');

  return (
    <section
      id="core-values"
      className="about-guiding-pillars section"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/guiding_pillars_background.webp)`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }}
    >
      <Container>
        <div ref={headerRef} className="pillars-header scroll-animate-blur">
          <div className="container section-badge flex items-center gap-3 text-[16px] md:text-[20px]">
            <div className="badge-dot"></div>
            Our Values
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl">Our Guiding Pillars</h2>
        </div>
        <div className="pillars-grid">
          <div ref={pillar1Ref} className="pillar-card scroll-animate-stagger hover-lift">
            <div className="pillar-icon hover-scale">
              <img src="/images/integrated_logistics.svg" alt="Integrated Logistics" loading="lazy" decoding="async" />
            </div>
            <h3 className="text-base md:text-lg lg:text-xl">Integrated Logistics</h3>
            <p className="text-sm md:text-base lg:text-lg">Door-to-door, multi-modal logistics covering Air, Rail, and Surface (LTL & FTL) for seamless nationwide movement.</p>
          </div>
          <div ref={pillar2Ref} className="pillar-card scroll-animate-stagger hover-lift">
            <div className="pillar-icon hover-scale">
              <img src="/images/customized_solutions.svg" alt="Customized Solutions" loading="lazy" decoding="async" />
            </div>
            <h3 className="text-base md:text-lg lg:text-xl">Customized Solutions</h3>
            <p className="text-sm md:text-base lg:text-lg">From in-city distribution to appointment-based deliveries, we handle urgent and specialized cargo with precision.</p>
          </div>
          <div ref={pillar3Ref} className="pillar-card scroll-animate-stagger hover-lift">
            <div className="pillar-icon hover-scale">
              <img src="/images/value_added_services.svg" alt="Value-Added Services" loading="lazy" decoding="async" />
            </div>
            <h3 className="text-base md:text-lg lg:text-xl">Value-Added Services</h3>
            <p className="text-sm md:text-base lg:text-lg">We offer forward stocking, consolidation, reverse logistics, and specialized B2C delivery across industries.</p>
          </div>
          <div ref={pillar4Ref} className="pillar-card scroll-animate-stagger hover-lift">
            <div className="pillar-icon hover-scale">
              <img src="/images/real_time_visibility.svg" alt="Real-Time Visibility" loading="lazy" decoding="async" />
            </div>
            <h3 className="text-base md:text-lg lg:text-xl">Real-Time Visibility</h3>
            <p className="text-sm md:text-base lg:text-lg">Tech-enabled systems provide live shipment tracking, real-time updates, and integration with your ERP.</p>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default AboutGuidingPillars;
